import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';

import { getGatewayDetail } from 'api/gateways';
import { updateGateway } from 'store/objects/actions';

import ObjectDescriptors from '../../components/ObjectDescriptors';
import GatewayConfig from './GatewayConfig';

import './styles.scss';
import 'Modals/modals.scss';

const tabStyle = {
  border: 'none',
  color: '#d0d4d6',
  fontSize: 16,
  fontWeight: 600,
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6d8994',
    backgroundColor: '#f7f7f7',
  },
};

const GatewayDetail = ({ object }) => {
  const dispatch = useDispatch();
  const { cusID: customerUUID, ecoID: ecosystemUUID } = useParams();

  const [gateway, setGateway] = useState(object);
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    const fetchGateayDetail = async () => {
      const result = await getGatewayDetail({ customerUUID, ecosystemUUID, uuid: object.uuid });
      setGateway(result);
      dispatch(updateGateway({ ecosystemUUID, result: object }));
    };
    fetchGateayDetail();
  }, [customerUUID, dispatch, ecosystemUUID, object]);

  return (
    <Box id="object__tabs">
      <Tabs
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value)}
        sx={{
          border: 'none',
          px: { xs: 2, md: 5 },
          pt: 2,
          '& .MuiTabs-indicator': {
            backgroundColor: '#11AEFB',
          },
        }}
      >
        <Tab value={1} label="Configuration" className="object__tab" sx={tabStyle} />
        <Tab value={2} label="Descriptors" className="object__tab" sx={tabStyle} />
      </Tabs>
      {selectedTab === 1 && <GatewayConfig data={gateway} />}
      {selectedTab === 2 && <ObjectDescriptors object={object} />}
    </Box>
  );
};

GatewayDetail.propTypes = {
  object: PropTypes.object.isRequired,
};

export default GatewayDetail;
